export enum ErrorTypes {
  UNKNOWN = 'UNKNOWN',
  MIN_BOUND = 'MIN_BOUND',
  DPI_BOUND = 'DPI_BOUND',
  HARD_BOUNDARY = 'HARD_BOUNDARY',
  MAX_BOUND = 'MAX_BOUND',
  COPYRIGHT = 'COPYRIGHT',
  CONFIGURATION_OVERLAP = 'CONFIGURATION_OVERLAP',
  COLOR_OVERLAP = 'COLOR_OVERLAP',
  UNSUPPORTED_UNICODE = 'UNSUPPORTED_UNICODE',
}
